export const readOnlyChip = theme => ({
  display: 'flex',
  height: '24px',
  minWidth: '40px',
  padding: '4px 10px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '9999px',
  border: `1px solid ${theme.tokens.SemColorBorderMuted}`,
  background: 'transparent',
  color: theme.tokens.SemColorOnSurfaceDefault,
  textAlign: 'center',
  fontFamily: 'Roboto Flex',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '100%',
  cursor: 'default'
});